export default () => {
    const breadcrumbLastChild = $('.category-breadcrumb .category-crumb:first-child .category-name');

    breadcrumbLastChild.on('click', (e) => {
        e.preventDefault();
    });
};
